module.exports = __webpack_public_path__ + "static/media/jcb.4f3aa7be.png";